import { combineEpics, createEpicMiddleware, Epic } from 'redux-observable';
import { AnyAction, configureStore, Middleware } from '@reduxjs/toolkit';
import { StoreConfiguration } from '../storeConfiguration.model';

type RootEpic = Epic<AnyAction, AnyAction, any>;


export function createCombinedFeatureStore<
  TDeps extends Record<string, any>
>(
  features: StoreConfiguration<any, any, any>[],
  dependencies: TDeps
) {
  let reducerMap = {};
  const middlewares: Middleware[] = [];
  const epicSet = new Set<RootEpic>();

  features.forEach((feature) => {
    reducerMap = { ...reducerMap, ...feature.reducerMap };

    feature.middlewares.forEach((middleware: Middleware) => {
      middlewares.push(middleware);
    });

    feature.epics.forEach((epic: Epic) => {
      epicSet.add(epic);
    });
  });

  const epicMiddleWare = createEpicMiddleware({ dependencies });

  const store = configureStore({
    middleware: [epicMiddleWare, ...middlewares],
    reducer: reducerMap,
  });

  epicMiddleWare.run(combineEpics(...Array.from(epicSet)));

  return store;
}
